export enum NotificationLevel {
	SUCCESS,
	INFORMATION,
	WARNING,
	ERROR,
	DESTROY
}
